import { ConsoleLogger } from './implementations';
import { ILogger, LogLevel } from './interfaces';

export class Logger {

  private static _loggers: ILogger[] = [new ConsoleLogger()];

  static debug(message: any) {
    this.log(message, 'debug');
  }

  static info(message: any) {
    this.log(message, 'info');
  }

  static error(message: any) {
    this.log(message, 'error');
  }

  static log(message, logLevel: LogLevel) {
    this._loggers.forEach(logger => {
      logger.log(message, logLevel);
    });
  }
}
